module.exports = __webpack_public_path__ + "static/media/IMG_20191127_133833.397240bd.jpg";